import { jsx as _jsx } from "react/jsx-runtime";
import { ToastContainer, toast } from 'react-toastify';
import { styled } from 'styled-components';
import { InfoIcon, CloseButton, Message } from './common';
export { injectStyle as injectNotificationsStyle } from 'react-toastify/dist/inject-style';
export { AppBarNotification } from './AppBar';
export { InlineNotification as Notification } from './Inline';
const StyledContainer = styled(ToastContainer) `
  /* stylelint-disable selector-class-pattern */

  /* https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity */
  &&&.Toastify__toast-container {
    top: 12px;
    width: fit-content;
    min-width: 320px;
  }

  .Toastify__toast {
    font-family: inherit;
    box-shadow: none;
    border-radius: 8px;
    min-height: 36px;
    max-height: none;

    &.Toastify__toast--success {
      background-color: ${({ theme }) => theme.colors.positive10};
      border: 1px solid ${({ theme }) => theme.colors.positive30};
    }

    &.Toastify__toast--error {
      background-color: ${({ theme }) => theme.colors.critical10};
      border: 1px solid ${({ theme }) => theme.colors.critical30};
    }

    &.Toastify__toast--info {
      background-color: ${({ theme }) => theme.colors.link10};
      border: 1px solid ${({ theme }) => theme.colors.link30};
    }

    &.Toastify__toast--warning {
      background-color: ${({ theme }) => theme.colors.warning10};
      border: 1px solid ${({ theme }) => theme.colors.warning30};
    }
  }

  .Toastify__toast-body {
    padding: 0;
    align-items: normal;
  }
  /* stylelint-enable selector-class-pattern */
`;
const getCommonProps = ({ toastId, type }) => ({
    icon: _jsx(InfoIcon, { type: type }),
    closeButton: CloseButton,
    toastId,
});
export const useNotification = () => ({
    error: ({ title, body, type, toastId }) => toast.error(_jsx(Message, { title: title, body: body, type: 'error' }), getCommonProps({ toastId, type })),
    info: ({ title, body, type, toastId }) => toast.info(_jsx(Message, { title: title, body: body, type: 'default' }), getCommonProps({ toastId, type })),
    success: ({ title, body, type, toastId }) => toast.success(_jsx(Message, { title: title, body: body, type: 'success' }), getCommonProps({ toastId, type })),
    warn: ({ title, body, type, toastId }) => toast.warn(_jsx(Message, { title: title, body: body, type: 'warning' }), getCommonProps({ toastId, type })),
});
export const NotificationsContainer = () => _jsx(StyledContainer, { closeButton: CloseButton, position: 'top-center', hideProgressBar: true });
